import axios from "axios";
import { awsUrl, url } from "../../axiosInstance";
import * as actionType from "../store/action";
import showAlert from "../server/ShowAlert";
import { setPreload } from "../server/CartsOpen";

export const getFilters = () => {
  return (dispatch) => {
    axios
      .get(`${awsUrl}/v1/parameters/filters`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch({ type: actionType.SET_FILTER, payload: x.data });
      })
      .catch(() => console.log("error"));
  };
};

export const addFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: actionType.ADD_FILTER, payload: filter });
  };
};

export const editFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: actionType.EDIT_FILTER, payload: filter });
  };
};
export const ParameterDelete = (data) => {
  const parameterId = data.parameterId;
  const id = data.id;
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .delete(`${awsUrl}/v1/parameters/${parameterId}/${id}`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        if (x.data.success === true) {
          dispatch({
            type: actionType.DELETE_FILTER,
            payload: { Id: id, TableName: data.TableName },
          });
        } else {
          showAlert({
            msgTitle: "לא ניתן למחוק פריט זה",
            msgText: "יש מוצרים מקושרים למידע זה!",
            msgType: "error",
          });
        }
      })
      .catch((x) => {
        if (x.response?.status === 409) {
          showAlert({
            msgTitle: "לא ניתן למחוק פריט זה",
            msgText: "יש מוצרים מקושרים למידע זה!",
            msgType: "error",
          });
        } else {
          showAlert({
            msgTitle: "שגיאה במחיקת פריט",
            msgText: x.response?.data?.message || "אנא נסה שוב מאוחר יותר",
            msgType: "error",
          });
        }
      })
      .finally(() => dispatch(setPreload(false)));
  };
};

export const ParameterName = (parameterName) => {
  return (dispatch) =>
    axios
      .get(`${awsUrl}/v1/parameters/${parameterName}`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) =>
        dispatch({
          type: actionType.SET_PARAMETER,
          key: parameterName,
          data: x.data,
        }),
      );
};
export const editParameter = (data) => {
  return (dispatch) => {
    axios
      .put(`${awsUrl}/v1/parameters`, data, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch(editFilter(x.data));
      });
  };
};
export const addParameter = (data) => {
  return (dispatch) => {
    axios
      .post(`${awsUrl}/v1/parameters`, data, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch(addFilter(x.data));
      });
  };
};
